import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=239a046a&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"
import style0 from "./Teams.vue?vue&type=style&index=0&id=239a046a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a046a",
  null
  
)

export default component.exports